import { AxiosResponse } from 'axios';
import { IEFConfiguration, IEFTargetSettingsDtoIn, IEFTargetSettingsDtoOut } from '../../Model/Dto/EmpowermentFinancing';
import { axiosCoreInstance } from '../AxiosCoreInterceptor';
import * as ApiUrls from './ApiUrl.EmpowermentFinancing';

export const EmpowermentFinancingService = {
	getConfiguration: (): Promise<AxiosResponse<IEFConfiguration>> =>
		axiosCoreInstance.get(ApiUrls.getConfiguration),

	getSettings: (scorecardId: string): Promise<AxiosResponse<IEFTargetSettingsDtoOut>> =>
		axiosCoreInstance.get(ApiUrls.getSettings(scorecardId)),

	saveSettings: (settings: IEFTargetSettingsDtoIn): Promise<AxiosResponse<IEFTargetSettingsDtoOut>> =>
		axiosCoreInstance.post(ApiUrls.saveSettings, settings),
};
